import { observer } from 'mobx-react-lite';
import { Fragment, useEffect } from 'react';
import { Header, Label, Pagination, Segment } from 'semantic-ui-react';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { useStore } from '../../../app/stores/store';
import { Button } from 'semantic-ui-react';
import MediaAssetListItem from './MediaAssetListItem';
import { useNavigate } from 'react-router';
import './styles.css';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';

export default observer(function MediaAssetList() {
  const { activityStore, dashboardStore, commonStore } = useStore();
  const { groupedActivities, groupedActivitiesAll, Filter, FilterCategory } =
    activityStore;
  // const [pageNumber, setPageNumber] = useState(1);
  // const [postsPerPage] = useState(10);
  // const userID = userStore.user?.id !== undefined ? userStore.user?.id : "";
  const history = useNavigate();

  useEffect(() => {
    activityStore.filteredAssetsCount =
      dashboardStore?.dashboard?.inventoryCount2 || 1;
    // eslint-disable-next-line
  }, [dashboardStore?.dashboard?.inventoryCount2]);
  useEffect(() => {
    if (activityStore.peopleData === true) {
      if (groupedActivitiesAll?.[0]?.[1].length === undefined) {
        activityStore.videoIntelligenceCount(1);
      } else {
        activityStore.videoIntelligenceCount(
          groupedActivitiesAll?.[0]?.[1].length,
        );
      }
    }
    // eslint-disable-next-line
  }, [groupedActivitiesAll]);

  useEffect(() => {
    // activityStore.currentPage = 1;
    activityStore.searchAndItemGroupsAndFilter();
    activityStore.itemGroupIdAPI();
    // eslint-disable-next-line
  }, [
    activityStore.FilterById,
    activityStore.FilterCategory,
    activityStore.filterMethod,
  ]);

  const onPageChangeHandler = (_event: any, data: any) => {
    activityStore.currentPage = parseInt(data?.activePage || 1);
    activityStore.searchAndItemGroupsAndFilter();
  };

  const filterActivitiesByCategory = (act: any) => {
    if (
      act?.filter(
        (a: any) =>
          a?.asset_tracking_status
            ?.toLowerCase()
            ?.includes(FilterCategory?.toLowerCase()),
      )?.length
    ) {
      return act?.filter(
        (a: any) =>
          a?.asset_tracking_status
            ?.toLowerCase()
            ?.includes(FilterCategory?.toLowerCase()),
      );
    } else if (
      act?.filter(
        (a: any) =>
          a?.asset_tracking_status?.includes(
            FilterCategory.charAt(0).toUpperCase() +
              FilterCategory.slice(1)
                .replace(/([A-Z][a-z])/g, ' $1')
                .trim(),
          ),
      )?.length
    ) {
      return act?.filter(
        (a: any) =>
          a?.asset_tracking_status?.includes(
            FilterCategory.charAt(0).toUpperCase() +
              FilterCategory.slice(1)
                .replace(/([A-Z][a-z])/g, ' $1')
                .trim(),
          ),
      );
    }
  };

  if (activityStore.loadingInitial)
    return <LoadingComponent content="Loading Activities...." />;

  const groupData =
    activityStore.peopleData === true
      ? groupedActivitiesAll
      : groupedActivities;

  return (
    <>
      <div className="metadata-report-redirection">
        {commonStore.filterModeTwo?.includes('RMDB01') ? (
          <></>
        ) : (
          <Button
            onClick={() => history('/reports')}
            disabled={commonStore.filterModeZero?.includes('RMDB01')}
            //MetaData Reports
          >
            {
              (userLanguage[0].Sidebar?.M10I01 as any)?.[
                `${commonStore.language.key}`
              ]
            }
          </Button>
        )}

        <div className="listPageAssetPagination">
          <Pagination
            className="listPageAssetPagination-page"
            // defaultActivePage={activityStore.currentPage || 1}
            activePage={activityStore.currentPage}
            totalPages={Math.ceil(
              (activityStore?.filteredAssetsCount ||
                dashboardStore?.dashboard?.inventoryCount2) / 10,
            )}
            onPageChange={onPageChangeHandler}
          />
        </div>
      </div>

      {!groupData?.length && !activityStore.isFilterApiCalled ? (
        <div
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
          }}
        >
          <img
            src={'/assets/noData.svg'}
            alt={'no data'}
            width={'300px'}
            height={'300'}
          />
          <h2>Oops!! No Data</h2>
        </div>
      ) : !activityStore.isFilterApiCalled ? (
        <>
          {groupData?.map(([group, activities]) => (
            <Fragment key={group}>
              {(activities?.filter(
                (a) => a?.title?.toLowerCase()?.includes(Filter?.toLowerCase()),
              )?.length ||
                activities?.filter(
                  (a) =>
                    a?.physical_sensor_qrcode
                      ?.toLowerCase()
                      ?.includes(Filter?.toLowerCase()),
                )?.length ||
                activities?.filter(
                  (a) =>
                    a?.physical_sensor_RFID
                      ?.toLowerCase()
                      ?.includes(Filter?.toLowerCase()),
                )?.length ||
                activities?.filter(
                  (a) =>
                    a?.physical_sensor_NFC
                      ?.toLowerCase()
                      ?.includes(Filter?.toLowerCase()),
                )?.length ||
                activities?.filter(
                  (a) =>
                    a?.physical_sensor_barcode
                      ?.toLowerCase()
                      ?.includes(Filter?.toLowerCase()),
                )?.length) &&
              (activities?.filter(
                (a) =>
                  a?.asset_tracking_status
                    ?.toLowerCase()
                    ?.includes(FilterCategory?.toLowerCase()),
              )?.length ||
                activities?.filter(
                  (a) =>
                    a?.asset_tracking_status?.includes(
                      FilterCategory.charAt(0).toUpperCase() +
                        FilterCategory.slice(1)
                          .replace(/([A-Z][a-z])/g, ' $1')
                          .trim(),
                    ),
                )?.length) ? (
                <>
                  <Header sub color="teal" style={{ margin: '0px' }}>
                    <Label content={group?.toUpperCase()} color="teal" />
                  </Header>
                  <Segment className="smallmediaassetlist largemediaassetlist">
                    {filterActivitiesByCategory(
                      activities?.filter(
                        (a) =>
                          a?.title
                            ?.toLowerCase()
                            ?.includes(Filter?.toLowerCase()) ||
                          a?.physical_sensor_NFC
                            ?.toLowerCase()
                            ?.includes(Filter?.toLowerCase()) ||
                          a?.physical_sensor_barcode
                            ?.toLowerCase()
                            ?.includes(Filter?.toLowerCase()) ||
                          a?.physical_sensor_qrcode
                            ?.toLowerCase()
                            ?.includes(Filter?.toLowerCase()) ||
                          a?.physical_sensor_RFID
                            ?.toLowerCase()
                            ?.includes(Filter?.toLowerCase()),
                      ),
                    )?.map((activity: any) => (
                      <>
                        <MediaAssetListItem
                          key={activity?.id}
                          activity={activity}
                        />
                      </>
                    ))}
                  </Segment>
                  <hr
                    style={{
                      border: '0',
                      height: '0',
                      borderTop: '1px solid rgba(0, 0, 0, 0.1)',
                      borderBottom: '1px solid rgba(255, 255, 255, 0.3)',
                    }}
                  />
                </>
              ) : (
                <></>
              )}
            </Fragment>
          ))}
        </>
      ) : (
        <div style={{ height: '80vh' }}>
          <LoadingComponent />
        </div>
      )}
    </>
  );
});
